import React, { useEffect, useState, useRef } from 'react';
import NotificationAlert from 'react-notification-alert';
import {
  Button,
  Card,
  Input,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Label,
  Form,
  Modal,
  ModalBody,
  FormGroup,
  Table,
  Progress,
} from 'reactstrap';
import { db } from '../../MY_LOGIN_AND_SIGNUP/db/config';
import { useForm } from 'react-hook-form';
import { format } from 'date-fns';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowLeftSharpIcon from '@mui/icons-material/KeyboardArrowLeftSharp';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import NotificationDialog from './NotificationDialog';
import Dialog from '@mui/material/Dialog';
import { Delete } from '@mui/icons-material';
import DeleteNotification from './DeleteNotification';
import DeleteSelected from './DeleteSelected';
import { algoliaAppID, algoliaSearchID } from '../../Utilities/algoliaKeys';
import algoliasearch from 'algoliasearch/lite';

function NotificationList() {
  const [limit, setLimit] = useState(10);

  const notification = useRef();
  const [progressVisible, setProgressVisible] = useState(true);
  const [progressValue, setProgressValue] = useState(8);
  const [notificationData, setNotificationData] = useState([]);
  const [isfilter, setIsFilter] = useState(false);
  const { handleSubmit, register } = useForm();
  const [startIndex, setStartIndex] = useState(1);
  const [endIndex, setEndIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [currentData, setCurrentData] = useState('');
  const [isAllDeleteModalVisible, setIsAllDeleteModalVisible] = useState(false);
  const [allChecked, setAllChecked] = useState(false);
  const [selected, setSelected] = useState(false);
  const [selectedArr, setSelectedArr] = useState([]);
  const [notificationSearchValue, setNotificationSearchValue] = useState('');
  const searchClient = algoliasearch(algoliaAppID, algoliaSearchID);
  const notificationSearchIndex = searchClient.initIndex(
    'Notifications_Search'
  );
  const [search, setSearch] = useState(false);

  const notify = (msg, err) => {
    let color = err === true ? 'danger' : 'success';
    let options = {
      type: color,
      place: 'tr',
      message: (
        <div>
          <div>
            <b>{err === true ? 'Error' : 'Success'}</b> -{msg}.
          </div>
        </div>
      ),
      icon: 'tim-icons icon-bell-55',
      autoDismiss: 6,
    };
    if (notification.current) {
      notification.current.notificationAlert(options);
    }
  };

  const getNotifications = () => {
    setProgressValue(99);
    document.querySelector('#loading-indicator').style.display = 'flex';
    db.collection('notifications')
      .orderBy('createdAt', 'desc')
      .limit(limit)
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        console.log('Mactest');
        data = data.map((item) => {
          return {
            createAtActual: item.createdAt,
            createdAt: item.createdAt
              ? format(
                new Date(item.createdAt.seconds * 1000),
                'dd-LL-yyyy hh:mm aa'
              )
              : 'N/A',
            message: item.message,
            type: item.type,
            itemID: item.itemID,
            select: false,
          };
        });
        setProgressVisible(false);
        setNotificationData(data);
        setEndIndex(data.length);
        document.querySelector('#loading-indicator').style.display = 'none';
      });
  };

  useEffect(() => {
    getNotifications();
  }, [isfilter, open, limit]);

  const onSubmit = (data) => {
    document.querySelector('#loading-indicator').style.display = 'flex';

    let fromDate = new Date(data.fromDate);
    let toDate = new Date(data.toDate);
    db.collection('notifications')
      .orderBy('createdAt', 'desc')
      .where('createdAt', '>=', fromDate)
      .where('createdAt', '<=', toDate)
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        data = data.map((item) => {
          let time = new Date(item.createdAt.seconds * 1000).toLocaleString();

          return {
            createdAt: time,
            message: item.message,
            type: item.type,
            itemID: item.itemID,
          };
        });
        document.querySelector('#loading-indicator').style.display = 'none';

        setNotificationData(data);
      })
      .catch((err) => {
        document.querySelector('#loading-indicator').style.display = 'none';
        notify(err.toString(), true);
        console.log(err.toString());
      });
  };

  const nextSet = () => {
    document.querySelector('#loading-indicator').style.display = 'flex';
    db.collection('notifications')
      .orderBy('createdAt', 'desc')
      .startAfter(notificationData[notificationData.length - 1].createAtActual)
      .limit(limit)
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        data = data.map((item) => {
          let time = new Date(item.createdAt.seconds * 1000).toLocaleString();

          return {
            createAtActual: item.createdAt,
            createdAt: time,
            message: item.message,
            type: item.type,
            itemID: item.itemID,
          };
        });
        if (data.length !== 0) {
          document.querySelector('#loading-indicator').style.display = 'none';

          setNotificationData(data);
          setStartIndex(endIndex + 1);
          setEndIndex((prev) => prev + data.length);
        } else {
          document.querySelector('#loading-indicator').style.display = 'none';

          notify('End Of the list', true);
        }
      })
      .catch((err) => {
        document.querySelector('#loading-indicator').style.display = 'none';
        notify(err.toString(), true);
        console.log(err.toString());
      });
  };

  const prevSet = () => {
    document.querySelector('#loading-indicator').style.display = 'flex';

    db.collection('notifications')
      .orderBy('createdAt')
      .startAfter(notificationData[0].createAtActual)
      .limit(limit)
      .get()
      .then((querySnapshot) => {
        let data = querySnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));

        data = data.map((item) => {
          let time = new Date(item.createdAt.seconds * 1000).toLocaleString();

          return {
            createAtActual: item.createdAt,
            createdAt: time,
            message: item.message,
            type: item.type,
            itemID: item.itemID,
          };
        });
        if (data.length !== 0) {
          document.querySelector('#loading-indicator').style.display = 'none';

          data = data.reverse();
          setStartIndex((prev) => prev - data.length);
          setEndIndex((prev) => prev - notificationData.length);
          setNotificationData(data);
        } else {
          document.querySelector('#loading-indicator').style.display = 'none';
        }
      })
      .catch((err) => {
        document.querySelector('#loading-indicator').style.display = 'none';
        notify(err.toString(), true);
        console.log(err.toString());
      });
  };

  const deleteNotification = () => {
    console.log('ye wala');
    db.collection('notifications')
      .doc(currentData)
      .delete()
      .then((res) => {
        setNotificationData((prev) =>
          prev.filter((item) => item.itemID !== currentData)
        );
        setIsDeleteModalVisible(false);
      })
      .catch((err) => {
        console.log(err);
        setIsDeleteModalVisible(false);
      });
  };

  const deleteSelected = () => {
    let selectedId = [];
    notificationData.map((item) => {
      if (item.select && item.itemID != undefined) {
        selectedId.push(item.itemID);
      }
    });

    let batch = db.batch();
    for (let i = 0; i < selectedId.length; i++) {
      batch.delete(db.collection('notifications').doc(selectedId[i]));
    }

    batch
      .commit()
      .then(() => {
        setNotificationData((prev) =>
          prev.filter((item) => !selectedId.includes(item.itemID))
        );
        setIsAllDeleteModalVisible(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const notificationSearch = () => {
    if (notificationSearchValue == '') {
      notify('Search field can not be empty', true);
    } else {
      setSearch(true);
      document.querySelector('#loading-indicator').style.display = 'flex';

      notificationSearchIndex
        .search(notificationSearchValue, { typoTolerance: false })
        .then((result) => {
          if (result.hits.length === 0) {
            document.querySelector('#loading-indicator').style.display = 'none';

            notify('No results found', true);
          } else {
            document.querySelector('#loading-indicator').style.display = 'none';
            console.log('result:', result.hits);
            let data = result.hits.map((item) => {
              console.log('item:', item);
              const time = item.createdAt.seconds * 1000;

              return {
                createdAt: time,
                id: item.id,
                itemID: item.itemID,
                message: item.message,
                objectID: item.objectID,
                stuId: item.stuId,
                type: item.type,
              };
            });
            setNotificationData(data);
            // setReload(true);
          }
        })
        .catch((err) => {
          if (document.querySelector('#loading-indicator') !== null)
            document.querySelector('#loading-indicator').style.display = 'none';
          notify(err.toString(), true);
        });
    }
  };

  const emptyCall = () => {
    getNotifications();

    setSearch(false);
  };

  return (
    <>
      {progressVisible ? (
        <Progress color='info' value={progressValue} style={{ height: 4 }} />
      ) : (
        <div className='content'>
          <div className='react-notification-alert-container'>
            <NotificationAlert ref={notification} />
          </div>
          <Modal
            isOpen={isDeleteModalVisible}
            color='primary'
            style={{
              display: 'flex',
              flex: 1,
              top: -40,
              width: 250,
              backgroundColor: '#132639',
              objectFit: 'fill',
            }}
          >
            <ModalBody size='sm'>
              <DeleteNotification
                setIsDeleteModalVisible={setIsDeleteModalVisible}
                deleteNotification={deleteNotification}
              />
            </ModalBody>
          </Modal>
          <Modal
            isOpen={isAllDeleteModalVisible}
            color='primary'
            style={{
              display: 'flex',
              flex: 1,
              top: -40,
              width: 350,
              backgroundColor: '#132639',
              objectFit: 'fill',
            }}
          >
            <ModalBody size='sm' style={{ textAlign: 'center' }}>
              <DeleteSelected
                setIsAllDeleteModalVisible={setIsAllDeleteModalVisible}
                deleteSelected={deleteSelected}
              />
            </ModalBody>
          </Modal>
          <Dialog fullScreen open={open} onClose={setOpen}>
            <NotificationDialog notifi={notification} handleClose={setOpen} />
          </Dialog>
          <Card>
            <Row>
              <Col sm={12}>
                <CardHeader
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <Col sm={9} style={{ textAlign: 'center' }}>
                    <CardTitle tag='h4' style={{ fontWeight: 300 }}>
                      NOTIFICATION MANAGEMENT
                    </CardTitle>
                  </Col>
                  <Col sm={3}>
                    <Button
                      color='info'
                      style={{ float: 'right' }}
                      onClick={() => {
                        setOpen(true);
                      }}
                    >
                      New Notification
                    </Button>
                  </Col>
                </CardHeader>
              </Col>
            </Row>
            <CardBody>
              <Row>
                <Col sm={selected || selectedArr.length > 0 ? 11 : 12}>
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <FormGroup
                      row
                      style={{ justifyContent: 'flex-end', height: '50px' }}
                    >
                      {isfilter ? (
                        <>
                          <Col sm={1}>
                            <Label style={{ minWidth: '70px' }} for='fromData'>
                              {' '}
                              From Date
                            </Label>
                          </Col>
                          <Col sm={3}>
                            <input
                              className='form-control dateclass placeholderclass'
                              {...register('fromDate', { required: true })}
                              type='date'
                              name='fromDate'
                              max={new Date(
                                new Date().setHours(new Date().getHours() + 6)
                              )
                                .toISOString()
                                .substr(0, 10)}
                              placeholder='From Date'
                            />
                          </Col>
                          <Col sm={1}>
                            <Label for='toData'> To Date</Label>
                          </Col>
                          <Col sm={3}>
                            <input
                              className='form-control dateclass placeholderclass'
                              {...register('toDate', { required: true })}
                              type='date'
                              name='toDate'
                              max={new Date(
                                new Date().setHours(new Date().getHours() + 6)
                              )
                                .toISOString()
                                .substr(0, 10)}
                              placeholder='To Date'
                            />
                          </Col>
                          <Col style={{ paddingLeft: '0px' }} sm={3}>
                            <Button
                              style={{ margin: '0px', padding: '6px 10px' }}
                              color='info'
                              type='submit'
                            >
                              <SearchIcon />
                            </Button>
                          </Col>
                        </>
                      ) : (
                        <Col
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                          }}
                          sm={6}
                        >
                          <p
                            style={{
                              position: 'relative',
                              top: '8px',
                              marginRight: '15px',
                            }}
                          >
                            {startIndex <= 1 ? 1 : startIndex} - {endIndex}
                          </p>
                          <div
                            style={{
                              position: 'relative',
                              top: '-5px',
                              marginRight: '0px',
                            }}
                          >
                            {startIndex > 1 && (
                              <IconButton style={{ outline: 'none' }}>
                                <KeyboardArrowLeftSharpIcon
                                  style={{ color: 'white' }}
                                  onClick={() => {
                                    prevSet();
                                  }}
                                />
                              </IconButton>
                            )}
                            <IconButton
                              style={{ outline: 'none' }}
                              onClick={() => nextSet()}
                            >
                              <KeyboardArrowRightSharpIcon
                                style={{ color: 'white' }}
                              />
                            </IconButton>
                          </div>

                          <select
                            className='form-control'
                            style={{
                              width: 81,
                              marginRight: 10,
                              position: 'relative',
                              top: 3,
                            }}
                            type='select'
                            value={limit}
                            onChange={(e) => {
                              setLimit(parseInt(e.target.value));
                              setAllChecked(false);
                            }}
                          // required
                          >
                            <option value='10'>10</option>
                            <option value='50'>50</option>
                            <option value='100'>100</option>
                          </select>
                        </Col>
                      )}
                      <Col style={{ paddingRight: '0px' }} sm={1}>
                        <Button
                          style={{ margin: '0px', padding: '6px 10px' }}
                          color={isfilter && 'info'}
                          onClick={() => setIsFilter(!isfilter)}
                        >
                          <FilterListIcon />
                        </Button>
                      </Col>
                    </FormGroup>
                  </Form>
                </Col>
                {selected || selectedArr.length > 0 ? (
                  <Col style={{ paddingRight: '0px' }} sm={1}>
                    <Button
                      style={{ margin: '0px', padding: '6px 10px' }}
                      color='danger'
                      onClick={() => setIsAllDeleteModalVisible(true)}
                    >
                      <Delete />
                    </Button>
                  </Col>
                ) : null}
              </Row>
              <Row>
                <Col sm={4}>
                  <input
                    className='form-control'
                    type='text'
                    name='searchInvoice'
                    placeholder='Search Notification'
                    onInput={(e) => {
                      setNotificationSearchValue(e.target.value);
                      e.target.value.length === 0 && emptyCall();
                    }}
                  />
                </Col>
                <Col style={{ paddingLeft: '0px' }} sm={2}>
                  <Button
                    style={{ margin: '0px', padding: '6px 10px' }}
                    color='info'
                    onClick={notificationSearch}
                  >
                    <SearchIcon />
                  </Button>
                </Col>
              </Row>
              <Table responsive>
                <thead className='text-primary'>
                  <tr>
                    <th width='5%'>
                      <input
                        type='checkbox'
                        checked={allChecked}
                        onChange={(e) => {
                          let checked = e.target.checked;
                          if (checked == true) {
                            setSelected(true);
                          } else {
                            setSelected(false);
                            setSelectedArr([]);
                          }
                          let checkedData = notificationData.map((data) => {
                            data.select = checked;
                            return data;
                          });
                          setAllChecked(checked);
                          setNotificationData(checkedData);
                        }}
                      />
                    </th>
                    <th width='20%'>Type</th>
                    <th width='50%' style={{ textAlign: 'start' }}>
                      Notification Message
                    </th>
                    <th width='18%' style={{ textAlign: 'center' }}>
                      Created At
                    </th>
                    <th width='7%' style={{ textAlign: 'center' }}>
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {notificationData.length === 0 && (
                    <tr>
                      <td></td>
                      <td></td>
                      <td style={{ textAlign: 'center' }}>No Data Found</td>
                      <td></td>
                      <td></td>
                    </tr>
                  )}
                  {notificationData.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <input
                            type='checkbox'
                            checked={item.select}
                            onChange={(e) => {
                              let checked = e.target.checked;
                              setNotificationData(
                                notificationData.map((data) => {
                                  if (item.itemID === data.itemID) {
                                    data.select = checked;
                                    if (checked) {
                                      setSelectedArr((prev) => [
                                        { id: item.itemID },
                                        ...prev,
                                      ]);
                                    } else {
                                      setSelectedArr((prev) =>
                                        prev.filter(
                                          (dataId) => dataId.id !== item.itemID
                                        )
                                      );
                                    }
                                  }
                                  if (e.target.checked == false) {
                                    setAllChecked(false);
                                  }
                                  return data;
                                })
                              );
                            }}
                          />
                        </td>
                        <td>{item.type}</td>
                        <td
                          style={{
                            textAlign: 'start',
                            textJustify: 'auto',
                            overflowWrap: 'anywhere',
                          }}
                        >
                          {item.message}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {item.createdAt}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          <Delete
                            onClick={() => {
                              setCurrentData(item.itemID);
                              setIsDeleteModalVisible(true);
                            }}
                            style={{ color: 'crimson', cursor: 'pointer' }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </div>
      )}
    </>
  );
}

export default NotificationList;
